import { render, staticRenderFns } from "./totem.vue?vue&type=template&id=d76a969a&"
import script from "./totem.vue?vue&type=script&lang=js&"
export * from "./totem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports